var _defs, _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuaranteeShield(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{opacity:.5;fill:#1e3744;enable-background:new}.st2{fill:#fff}.st5{fill:#000000}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_7_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_11_",
    fill: "#1e3744",
    d: "M92 78.2H8.1l3.6-11.4-3.6-11.4H92l-3.6 11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_10_",
    d: "M14 72.9l14.6 5.3s2.3-6.6 2.1-6.6S14 72.9 14 72.9z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    d: "M86.3 72.9l-14.6 5.3s-2.3-6.6-2.1-6.6c.3 0 16.7 1.3 16.7 1.3z",
    className: "st1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5_"
  }, /*#__PURE__*/React.createElement("image", {
    id: "XMLID_74_",
    width: 341,
    height: 371,
    opacity: 0.25,
    overflow: "visible",
    transform: "matrix(.24 0 0 .24 10.157 6.264)",
    xlinkHref: "97E157D3D3C8E863.png"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_63_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_73_",
    d: "M86 18.1L50.6 8.3c-.4-.1-.8-.1-1.2 0L14 18.1c-.9.3-1.6 1.1-1.6 2-.6 9.7-1.6 60.1 37.1 70.9.4.1.8.1 1.2 0 38.7-10.8 37.6-61.2 37.1-70.9-.2-.9-.8-1.7-1.8-2z",
    className: "st2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_4_",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_58_",
    fill: "#f1f1f2",
    d: "M50 11.9c-.4-.1-.7 0-1.1.1l-32.2 8.8c-.9.2-1.1.1-1.1 1-.5 9.1-1.8 55.5 33.2 65.6.4.1.9.3 1.2.2V11.9z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_3_",
    d: "M50 15.8l30.5 8.4c.4 11.9-.7 50.3-30.5 59.3-29.8-9-30.9-47.3-30.5-59.3L50 15.8m0-5.1c-.2 0-.4 0-.6.1L16.1 20c-.9.2-1.5 1-1.6 1.9C14 31 13 78.4 49.4 88.6c.2.1.4.1.6.1s.4 0 .6-.1C87 78.4 86 31 85.4 21.9c-.1-.9-.7-1.7-1.6-1.9l-33.3-9.2c-.1 0-.3-.1-.5-.1z",
    className: "st5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    d: "M31 43.5V33l-1.9 2-1.5-1.6 3.8-3.8h2.3v13.9H31z",
    className: "st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    d: "M41.3 43.5v-5.7L38 29.6h2.8l1.8 5.6 1.8-5.6h2.7l-3.2 8.1v5.7h-2.6z",
    className: "st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_18_",
    d: "M47.6 43.5V29.6h6.1v2.3h-3.5v3.4h3.3v2.3h-3.3v3.6h3.5v2.3h-6.1z",
    className: "st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20_",
    d: "M60.5 43.5l-.4-2.6h-2.6l-.4 2.6h-2.7l2.9-13.9h3l2.9 13.9h-2.7zm-1.7-11l-1 6.1h2l-1-6.1z",
    className: "st5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_23_",
    d: "M69 43.5l-1.5-5.1h-.9v5.1H64V29.6h3.9c2.2 0 3.8 1.8 3.8 4.3 0 2.4-1 3.4-1.8 3.8l1.9 5.7H69zm.1-9.5c0-1.3-.5-2.1-1.5-2.1h-.9v4.2h.9c.9 0 1.5-.9 1.5-2.1z",
    className: "st5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    fill: "#3f545e",
    d: "M14 50.2h72.3V73H14z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_29_",
    d: "M19.6 61.4c0-3.2 1-5.4 3.2-5.4 1.4 0 2.3 1.1 2.6 2.4l-1.5.6c-.2-.7-.4-1.3-1-1.3-.8 0-1.2 1.1-1.2 3.6s.5 3.6 1.2 3.6c.4 0 .7-.2.9-.5v-1.9h-1.2v-1.7h2.9v4.4c-.7.9-1.5 1.4-2.7 1.4-2.2.1-3.2-2.1-3.2-5.2z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_31_",
    d: "M27.1 63.5v-7.4h2v7.5c0 1 .4 1.4 1 1.4s1-.4 1-1.4v-7.5h2v7.4c0 2.2-1.4 3.2-3 3.2-1.5 0-3-.9-3-3.2z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_33_",
    d: "M38.7 66.5l-.3-1.9h-1.9l-.3 1.9h-2l2.2-10.4h2.3l2.2 10.4h-2.2zm-1.3-8.1l-.7 4.5h1.5l-.8-4.5z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_36_",
    d: "M45.5 66.5l-1.1-3.8h-.6v3.8h-2V56.2h2.9c1.6 0 2.8 1.3 2.8 3.2 0 1.8-.7 2.5-1.3 2.9l1.4 4.3h-2.1zm.1-7c0-.9-.4-1.6-1.1-1.6h-.6V61h.6c.7 0 1.1-.6 1.1-1.5z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_41_",
    d: "M53.1 66.5l-.3-1.9h-1.9l-.3 1.9h-2l2.2-10.4h2.3l2.2 10.4h-2.2zm-1.3-8.1l-.7 4.5h1.5l-.8-4.5z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_44_",
    d: "M60.3 66.5L58.2 61v5.5h-2V56.2h2l2 5.3v-5.3h2v10.4h-1.9z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_46_",
    d: "M65.1 66.5v-8.6h-1.6v-1.7h5.1v1.7H67v8.6h-1.9z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_48_",
    d: "M70 66.5V56.2h4.5v1.7h-2.6v2.5h2.5v1.7h-2.5v2.7h2.6v1.7H70z",
    className: "st2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_50_",
    d: "M76.2 66.5V56.2h4.5v1.7h-2.6v2.5h2.5v1.7h-2.5v2.7h2.6v1.7h-4.5z",
    className: "st2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuaranteeShield);
export default __webpack_public_path__ + "static/media/guarantee_shield.47a0be296f55e1b63cb4a5d727c41a91.svg";
export { ForwardRef as ReactComponent };